import React from "react";
import { Link } from "gatsby";
import Section from "../Section";
import GitHub from "../../../content/icons/GitHub";
import Twitter from "../../../content/icons/Twitter";
import Facebook from "../../../content/icons/Facebook";
import Rss from "../../../content/icons/Rss";

const Footer = () => (
  <footer className="bg-white w-full text-gray-500">
    <Section className="flex flex-col justify-center items-center space-y-6 text-lg">
      <div className="space-x-6">
        <Link to="/contact">Kontakt</Link>
        <Link to="/privacy">Datenschutz</Link>
        <Link to="/values">Unsere Werte</Link>
      </div>
      <div className="space-x-6 text-gray-500">
        <a
          className="hover:text-gray-700"
          href="https://github.com/F-WuTS"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="robo4you GitHub Page"
        >
          <GitHub />
        </a>
        <a
          className="hover:text-gray-700"
          href="https://twitter.com/robo4you"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="robo4you Twitter Page"
        >
          <Twitter />
        </a>
        <a
          className="hover:text-gray-700"
          href="https://facebook.com/robo4you"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="robo4you Facebook Page"
        >
          <Facebook />
        </a>
        <a
          className="hover:text-gray-700"
          href="/rss.xml"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="robo4you RSS newsfeed"
        >
          <Rss />
        </a>
      </div>
      <div className="text-gray-500">
        <p>
          {new Date().getFullYear()} - Verein zur Förderung von Wissenschaft und
          Technik an Schulen (F-WuTS)
        </p>
      </div>
    </Section>
  </footer>
);

export default Footer;
